import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveLast = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 14,
	viewBox: "0 0 24 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 0.500001L23.5 0.5L23.5 13.5L7 13.5L0.499999 7L7 0.500001Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5332 4.52881L17.4731 9.46875",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4731 4.52881L12.5332 9.46875",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRemoveLast;
